<template>
  <b-container fluid>
    <b-row>
     <b-col :lg="cols">
        <card>
          <TableActionHeader 
            ref="th" 
            v-on:filterChange="onFilterChange" 
            v-on:newItem="onNewItem"
            :newButton="$UIPrivilegeC('timetables/stops')">
          </TableActionHeader> 
          <StopTable ref="tbl" :filter="filter" v-on:selectItem="onSelectItem" ></StopTable>               
        </card>
      </b-col>
      <b-col>
        <InfoCard v-if="formType == ''"></InfoCard>
        <card v-if="formType == 'new'">
            <CardHeader :title="$t('item.new')" />
            <StopForm :item="item" :action="formType"></StopForm>                  
        </card>
        <card v-if="formType == 'edit'"> 
            <CardHeader :title="item ? item.nimi : ''" type="item" />
            <tabs @activate-tab="onTabChange">
                <tab-pane title="stop-form" key="stop-form">  <!-- v-if="$UIPrivilege('timetables/stops', 'information')"> -->
                    <b-icon id="stop-settings" slot="title" icon="gear" scale='1.1'></b-icon> 
                    <b-popover target="stop-settings" triggers="hover" placement="top">
                            {{$t("stops.tooltips.settings")}}
                            </b-popover>
                    <StopForm :item="item" :action="formType"></StopForm>                  
                </tab-pane>
                <tab-pane title="departures" :key="departuresTabKey" v-if="$UIPrivilege('timetables/stops', 'departures')">
                    <b-icon id="stop-departures" slot="title" icon="card-list" scale='1.1'></b-icon> 
                    <b-popover target="stop-departures" triggers="hover" placement="top">
                            {{$t('stops.tooltips.departures')}}
                            </b-popover> 
                    <StopDeparturesList :stopTunnus="item.tunnus" :opened="departuresTabOpened"></StopDeparturesList> 
                </tab-pane>
            </tabs>
        </card>

      </b-col>
     </b-row>
  </b-container>

</template>

<script>

import TableActionHeader from '@/components/Misc/TableActionHeader'
import CardHeader from '@/components/Misc/CardHeader'
import StopTable from '@/components/Timetable/StopTable.vue'
import StopForm from '@/components/Timetable/StopForm.vue'
import StopDeparturesList from '@/components/Map/StopDeparturesList.vue'

export default {
    name: 'Stops',
    components: {
        StopTable, StopForm, TableActionHeader, CardHeader, StopDeparturesList
    },
    data: function() {
        return {
            showForm: true,
            cols: 8,
            filter: null,
            defaultFormData: {
                "tunnus": null,
                "nimi": null,
                "sms": null,
                "laituri": null, 
                "location" : {
                    "latitude" :null  , 
                    "longitude" : null
                },
                "stopFeatures": []
            }, 
            item: {
                "tunnus": null,
                "nimi": null,
                "sms": null,
                "laituri": null, 
                "location" : {
                    "latitude" :null, 
                    "longitude" : null
                },
                "stopFeatures": []           
            },
            formType: "",
            departuresTabOpened: false,
            departuresTabKey: "departures"

        }
    },
    mounted() {
        if(this.$route.query.id) {
            this.filter = this.$route.query.id;
            this.$refs.th.setFilterValue(this.filter);
        }
    },
    methods: {
        showEditor: function(show, type) {
            this.showForm = show;
            this.formType = type;
            this.cols = this.showForm ? 8 : 12;
        },
        onFilterChange: function(filter) {
            this.filter = filter;
        },
        onNewItem: function() {
            this.item = Object.assign({}, this.defaultFormData);        
            this.showEditor(true, "new");
        },
        onSelectItem: function(item) {            
            if( item ) { 
                if( !item.location ) {
                    item.location = {
                        latitude : null, 
                        longitude : null
                    };
                }
                this.item = JSON.parse(JSON.stringify(item));
            }  
            this.showEditor(true, "edit");
        },
        onTabChange(tab) {
            this.departuresTabOpened = (tab.$vnode.data.key == this.departuresTabKey)
        },
        onClose(){
            this.showEditor(false, "");
        }
    }
}
</script>
